import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import FilterComponent from "../../../../../../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedAdGroupForContradictingSTDefinition,
  setSelectedCampaignForContradictingSTDefinition,
  setSelectedKeywordForContradictingSTDefinition,
} from "../../../../../../../../../features/searchTermTabSlice";

export default function ContradictingSTFilterItems({
  clearSelectedSearchTerm,
}: any) {
  const {
    contradictingSTDefinition,
    selectedCampaignForContradictingSTDefinition,
    selectedAdGroupForContradictingSTDefinition,
    selectedKeywordForContradictingSTDefinition,
  } = useSelector((state: any) => state.searchTermTab);

  const dispatch = useDispatch();

  const [searchAdgroups, setSearchAdgroups] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");
  const [searchKeywords, setSearchKeywords] = useState("");
  const filterConfig = [
    {
      key: "CampaignForContradictingST",
      name: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaignForContradictingSTDefinition,
      filterName: "campaign_name",
      data: contradictingSTDefinition,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedCampaignForContradictingSTDefinition(updatedSelection)
        ),
      count:
        selectedCampaignForContradictingSTDefinition &&
        selectedCampaignForContradictingSTDefinition.length,
      colorSelected:
        selectedCampaignForContradictingSTDefinition !== null &&
        selectedCampaignForContradictingSTDefinition.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AdgroupForContradictingST",
      name: "Adgroup",
      label: "Select one or more Adgroups",
      searchTerm: searchAdgroups,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdgroups(e.target.value),
      selectedOption: selectedAdGroupForContradictingSTDefinition,
      filterName: "adgroup_name",
      data: contradictingSTDefinition,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedAdGroupForContradictingSTDefinition(updatedSelection)
        ),
      count:
        selectedAdGroupForContradictingSTDefinition &&
        selectedAdGroupForContradictingSTDefinition.length,
      colorSelected:
        selectedAdGroupForContradictingSTDefinition !== null &&
        selectedAdGroupForContradictingSTDefinition.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "KeywordsForContradictingST",
      name: "Keyword",
      label: "Select one or more Keywords",
      searchTerm: searchKeywords,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchKeywords(e.target.value),
      selectedOption: selectedKeywordForContradictingSTDefinition,
      filterName: "keyword_name",
      data: contradictingSTDefinition,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedKeywordForContradictingSTDefinition(updatedSelection)
        ),
      count:
        selectedKeywordForContradictingSTDefinition &&
        selectedKeywordForContradictingSTDefinition.length,
      colorSelected:
        selectedKeywordForContradictingSTDefinition !== null &&
        selectedKeywordForContradictingSTDefinition.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedCampaignForContradictingSTDefinition([]));
    dispatch(setSelectedAdGroupForContradictingSTDefinition([]));
    dispatch(setSelectedKeywordForContradictingSTDefinition([]));
    clearSelectedSearchTerm(null);
    setSearchAdgroups("");
    setSearchCampaigns("");
    setSearchKeywords("");
  };

  return (
    <Box data-tracker="556" sx={{ position: "relative" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
